import { useEffect } from "react";

/**
 * Applies accessibility-related data attributes to `<html>` so global CSS can react.
 *
 * - `data-reduce-motion="true"` — disables transitions/animations
 * - `data-high-contrast="true"` — bumps contrast in supported components
 * - `data-font-size="small|medium|large"` — scales base font size
 */
export function useAccessibility(opts: {
  reduceMotion: boolean;
  highContrast: boolean;
  fontSize: "small" | "medium" | "large";
}) {
  useEffect(() => {
    const root = document.documentElement;
    root.dataset.reduceMotion = String(opts.reduceMotion);
    root.dataset.highContrast = String(opts.highContrast);
    root.dataset.fontSize = opts.fontSize;

    return () => {
      delete root.dataset.reduceMotion;
      delete root.dataset.highContrast;
      delete root.dataset.fontSize;
    };
  }, [opts.reduceMotion, opts.highContrast, opts.fontSize]);
}
